import {observer} from "mobx-react";
import {Linq} from "../../ui";
import {stsDetailStore} from "../../../store";
import {convertStsStatus, exportStsReason} from "../../../api";

function LinkIcon() {
    return <span className="material-symbols-outlined" style={{position: 'absolute', paddingLeft: '0.3em'}}>link</span>
}

const StsDetailPageIntro = observer(function StsDetailPageIntro() {
    return <div
        style={{
            padding: '1em',
            display: 'flex'
        }}
    >
        <div
            style={{
                flex: '1'
            }}
        >
            <div style={{marginBottom: '1em'}}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>Kunde</label>
                <Linq to={`/cms/${stsDetailStore.data?.customerId}`}>
                    <h4 className={"title is-4 has-text-primary"}>
                        {`${stsDetailStore.customerDisplay || '-'}`} <LinkIcon/>
                    </h4>
                </Linq>
            </div>
            <div style={{marginBottom: '1em'}}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>Prozess</label>
                <h4 className={"title is-4 has-text-primary"}>
                    {stsDetailStore.data?.reason ? exportStsReason(stsDetailStore.data?.reason!) : '-'}
                </h4>
            </div>
            <div style={{marginBottom: '1em'}}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>Status</label>
                <h4 className={"title is-4 has-text-primary"}>
                    {stsDetailStore.data?.status ? convertStsStatus(stsDetailStore.data?.status!) : '-'}
                </h4>
            </div>
            <div style={{marginBottom: '1em'}}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>Fahrzeug</label>
                <Linq to={`/vhs/${stsDetailStore.data?.customerId}/${stsDetailStore.data?.vin}`}><h4
                    className={"title is-4 has-text-primary"}>
                    {stsDetailStore.data?.vin} <LinkIcon/>
                </h4></Linq>
            </div>
            <div style={{marginBottom: '1em'}}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>Zielschrank</label>
                <h4 className={"title is-4 has-text-primary"}>
                    {stsDetailStore.data?.destinationCabinet}
                </h4>
            </div>
        </div>
        <div
            style={{
                flex: '1'
            }}
        >
            <div style={{marginBottom: '1em'}}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>Auslagerung</label>
                {stsDetailStore.data?.shipmentPackageId ?
                    <Linq to={`/fms/packages/${stsDetailStore.data?.shipmentPackageId}`}>
                    <span className={"label has-text-primary"}>
                        {`${stsDetailStore.data?.shipmentPackageId || '-'}`} {stsDetailStore.data?.shipmentPackageId && <LinkIcon/>}
                    </span>
                    </Linq> : <span className={"label has-text-primary"}>-</span>}
            </div>
            <div style={{marginBottom: '1em'}}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>Erfassung</label>
                {stsDetailStore.data?.vehicleDataAcquisitionId ?
                    <Linq to={`/vda/${stsDetailStore.data?.vehicleDataAcquisitionId}`}>
                    <span className={"label has-text-primary"}>
                        {`${stsDetailStore.data?.vehicleDataAcquisitionId || '-'}`} {stsDetailStore.data?.vehicleDataAcquisitionId && <LinkIcon/>}
                    </span>
                    </Linq> : <span className={"label has-text-primary"}>-</span>}
            </div>
            <div style={{marginBottom: '1em'}}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>Einlagerung</label>
                {stsDetailStore.data?.placementId ? <Linq to={`/sls/${stsDetailStore.data?.placementId}`}>
                    <span className={"label has-text-primary"}>
                        {`${stsDetailStore.data?.placementId || '-'}`} {stsDetailStore.data?.placementId && <LinkIcon/>}
                    </span>
                </Linq> : <span className={"label has-text-primary"}>-</span>}
            </div>
            {stsDetailStore.isSca && <div style={{marginBottom: '1em'}}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>Sicherheitscodeerfassung</label>
                <Linq to={`/sca/${stsDetailStore.data?.correlationId}`}>
                    <span className={"label has-text-primary"}>
                        {`${stsDetailStore.data?.correlationId || '-'}`} {stsDetailStore.data?.correlationId && <LinkIcon/>}
                    </span>
                </Linq>
            </div>}
            <div style={{marginBottom: '1em'}}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>Labeldrucker</label>
                {stsDetailStore.data?.labelPrinterId ? <Linq to={`/pms/${stsDetailStore.data?.labelPrinterId}`}>
                    <span className={"label has-text-primary"}>
                        {`${stsDetailStore.data?.labelPrinterId || '-'}`} {stsDetailStore.data?.labelPrinterId && <LinkIcon/>}
                    </span>
                </Linq> : <span className={"label has-text-primary"}>-</span>}
            </div>
        </div>
    </div>
})

export {
    StsDetailPageIntro
}
